import { flattenDeep, findIndex, map } from 'lodash';

//import ClassroomCourseCpnt from './ClassroomCourseCpnt/ClassroomCourseCpnt.store';
import MainModeFavorite from './MainModeFavorite/MainModeFavorite.store';
import MainModeRanking from './MainModeRanking/MainModeRanking.store';

import * as constants from './MainModeCourse.constants';
import * as services from './MainModeCourse.service';

const getVideos = (collection) =>
  Array.isArray(collection) &&
  flattenDeep(flattenDeep(collection.map((v) => v.readingList)).map((v) => v.bulletList)).map(
    (v, i, arr) => {
      return {
        bulletName: v.bulletName,
        bulletId: v.bulletId,
        videoId: v.videoId,
        speed1: v.vpath,
        speed1Dot3: v.vpath_1_3,
        speed1Dot5: v.vpath_1_5,
        speed2: v.vpath_2,
        isLatest: i === arr.length - 1,
        endOfReading: v.endOfReading ? true : false,
        collected: v.collected ? true : false,
      };
    }
  );

const state = {
  Course: {
    currentPoints: 0,
    totalPoints: 0,
  },
  Collection: [],
  ReadyToPlayVideos: [],
  isRequest: false,

  isDiagnosisLoading: false,
  diagnosisInfo: {},
  isTaskStatusLoading: false,
  taskStatusInfo: null,
  myTaskStatus: {},

  isMaterialLoading: false,
};

const mutations = {
  [constants.CLEAR_STATE](state) {
    state.Course = {
      currentPoints: 0,
      totalPoints: 0,
    };
    state.Collection = [];
    state.ReadyToPlayVideos = [];
    state.isRequest = false;
    //state.isRankingLoading = false;
    //state.rankingList = [];
    state.isDiagnosisLoading = false;
    state.diagnosisInfo = {};
  },

  [constants.GET_COURSE_SUCCESS](state, Course) {
    state.Course = Course;
    state.Collection = Course.collection;
    state.ReadyToPlayVideos = getVideos(state.Collection);
  },

  [constants.FILTER_MAIN_COLLECTION_BOOK](state, value) {
    if (value != 0) {
      state.Collection = state.Course.collection.filter((v) => v.bookId == value);
    } else {
      state.Collection = state.Course.collection;
    }
    state.ReadyToPlayVideos = getVideos(state.Collection);
  },

  [constants.ADD_VIDEO_TO_FAVORITE_LIST](state, bulletId) {
    const index = findIndex(state.ReadyToPlayVideos, (v) => v.bulletId === bulletId);
    if (index != -1) {
      const elem = state.ReadyToPlayVideos[index];
      elem.collected = !elem.collected;
    }
  },

  [constants.REMOVE_UNFOLLOW_VIDEOS](state) {
    const unFollowArr = state.ReadyToPlayVideos.filter((v) => !v.collected);
    if (unFollowArr.length) {
      unFollowArr.forEach((v) => {
        state.Collection.forEach((collection) => {
          collection.readingList.forEach((reading) => {
            reading.bulletList.forEach((bullet, i) => {
              if (bullet.bulletId === v.bulletId && !v.collected) {
                reading.bulletList.splice(i, 1);
              }
            });
          });
        });
      });

      state.Collection.forEach((collection) => {
        collection.readingList.forEach((reading, i) => {
          if (!reading.bulletList.length) {
            collection.readingList.splice(i, 1);
          }
        });
      });

      state.Collection.forEach((collection, i) => {
        if (!collection.readingList.length) {
          state.Collection.splice(i, 1);
        }
      });
      state.ReadyToPlayVideos = getVideos(state.Collection);
    }
  },

  [constants.GET_CLASS_RESTRICTION_WEB_TREE_PATH_SUCCESS](state, payload) {
    state.Course = {
      ...state.Course,
      files: map(state.Course.files, (file) => {
        if (payload.fileId === file.fileId) {
          return {
            ...file,
            filePath: payload.filePath,
          };
        } else {
          return file;
        }
      }),
    };
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.SET_DIAGNOSIS_LOADING](state, isDiagnosisLoading) {
    state.isDiagnosisLoading = isDiagnosisLoading;
  },

  [constants.GET_DIAGNOSIS_LIST_SUCCESS](state, diagnosisInfo) {
    state.diagnosisInfo = diagnosisInfo;
  },

  [constants.SET_TASK_STATUS_LOADING](state, isTaskStatusLoading) {
    state.isTaskStatusLoading = isTaskStatusLoading;
  },

  [constants.GET_TASK_STATUS_SUCCESS](state, taskStatusInfo) {
    state.taskStatusInfo = taskStatusInfo;
  },

  [constants.GET_MY_TASK_STATUS_SUCCESS](state, myTaskStatus) {
    if (undefined !== myTaskStatus && null !== myTaskStatus) {
      state.myTaskStatus = myTaskStatus;
    }
  },

  [constants.SET_MATERIAL_LOADING](state, isMaterialLoading) {
    state.isMaterialLoading = isMaterialLoading;
  },
};

const actions = {
  async getCourse({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const params = services.getCourse(payload);
    const res = await params;
    commit(constants.GET_COURSE_SUCCESS, res.data.data);
    if (res.data.data.currentServerTime) {
      commit('SET_CURRENT_SERVER_TIME', res.data.data.currentServerTime, { root: true });
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return params;
  },

  async getCourseWithoutSetRequestStatus({ commit }, payload) {
    const params = services.getCourse(payload);
    const res = await params;
    commit(constants.GET_COURSE_SUCCESS, res.data.data);
    return params;
  },

  async addToFavoriteList({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.addToFavoriteList(payload);
    if (res.data.data) {
      commit(constants.ADD_VIDEO_TO_FAVORITE_LIST, payload.bulletId);
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async getDiagnosisInfo({ commit }, payload) {
    commit(constants.SET_DIAGNOSIS_LOADING, true);
    const res = await services.getDiagnosisInfo(payload);
    if (res.data.data) {
      commit(constants.GET_DIAGNOSIS_LIST_SUCCESS, res.data.data);
    }
    commit(constants.SET_DIAGNOSIS_LOADING, false);
  },

  async getCourseTaskStatus({ commit }, payload) {
    commit(constants.SET_TASK_STATUS_LOADING, true);
    const res = await services.getCourseTaskStatus(payload);
    commit(constants.GET_TASK_STATUS_SUCCESS, res.data.data);
    commit(constants.SET_TASK_STATUS_LOADING, false);
  },

  async getCourseMultiTaskStatus({ commit }, payload) {
    commit(constants.SET_TASK_STATUS_LOADING, true);
    const res = await services.getCourseMultiTaskStatus(payload);
    commit(constants.GET_TASK_STATUS_SUCCESS, res.data.data);
    commit(constants.SET_TASK_STATUS_LOADING, false);
  },

  async getCourseMyTaskStatus({ commit }, payload) {
    commit(constants.SET_TASK_STATUS_LOADING, true);
    const res = await services.getCourseMyTaskStatus(payload);
    commit(constants.GET_MY_TASK_STATUS_SUCCESS, res.data.data);
    commit(constants.SET_TASK_STATUS_LOADING, false);
  },

  async getClassRestrictionWebTreePath({ commit }, payload) {
    commit(constants.SET_MATERIAL_LOADING, true);
    const res = await services.getClassRestrictionWebTreePath(payload);
    commit(constants.GET_CLASS_RESTRICTION_WEB_TREE_PATH_SUCCESS, {
      ...payload,
      filePath: res.data.data,
    });
    commit(constants.SET_MATERIAL_LOADING, false);
  },
};

const getters = {
  ReadyToPlayVideos: (state) => state.ReadyToPlayVideos,
  Course: (state) => state.Course,
  EarlyBooks: (state) => state.Course.earlyBooks,
  Files: (state) => state.Course.files,
  Books: (state) => {
    let Books =
      (Array.isArray(state.Course.books) && state.Course.books.filter((v) => v.bookStatus == 1)) ||
      [];
    Books = map(Books, (book) => {
      const isLockedByStudentWorkStatus =
        book.studentWorkEntity && 0 === book.studentWorkEntity.studentWorkStatus;
      const readings = map(book.readings, (reading) => {
        return {
          ...reading,
          c_isLockedByStudentWorkStatus: isLockedByStudentWorkStatus,
          c_isCanStudy: reading.canAccess && !isLockedByStudentWorkStatus,
        };
      });
      return {
        ...book,
        readings,
        c_isLockedByStudentWorkStatus: isLockedByStudentWorkStatus,
        c_isCanStudy: book.canAccess && !isLockedByStudentWorkStatus,
      };
    });
    return Books;
  },
  UnissuedBooks: (state) =>
    (Array.isArray(state.Course.books) && state.Course.books.filter((v) => v.bookStatus == -1)) ||
    [],
  FilterData: (state) =>
    Array.isArray(state.Course.collection) &&
    state.Course.collection.map((v) => ({ bookName: v.bookName, bookId: v.bookId })),
  Collection: (state) => state.Collection,
  hasCurrentBook: (state) => {
    if (Array.isArray(state.Course.books)) {
      const current = state.Course.books.find((v) => v.isCurrent);
      if (current) {
        return current;
      } else {
        return state.Course.books[0];
      }
    }
  },

  diagnosisInfo: (state) => state.diagnosisInfo,

  taskStatusInfo: (state) => {
    if (!state.taskStatusInfo) {
      return null;
    } else {
      const {
        finishedItem,
        totalItem,
        personalTaskFinishedCount,
        personalTaskTotalCount,
      } = state.taskStatusInfo;
      const percent = totalItem ? Math.floor((finishedItem / totalItem) * 100) : 0;
      const personalTaskPercent = personalTaskTotalCount
        ? Math.floor((personalTaskFinishedCount / personalTaskTotalCount) * 100)
        : 0;
      return {
        ...state.taskStatusInfo,
        percent,
        personalTaskPercent,
      };
    }
  },

  myTaskStatus: (state) => ({
    ...state.myTaskStatus,
    myXLYList: map(state.myTaskStatus.myXLYList, (myTaskStatus) => ({
      ...myTaskStatus,
      percent: myTaskStatus.xlyTotalCount
        ? Math.floor((myTaskStatus.xlyFinishedCount / myTaskStatus.xlyTotalCount) * 100)
        : 0,
    })),
  }),
};

export default {
  namespaced: true,
  modules: {
    //ClassroomCourseCpnt,
    MainModeFavorite,
    MainModeRanking,
  },
  state,
  mutations,
  actions,
  getters,
};
